let routerNavigate: ((path: string) => void) | null = null;

// Register navigation function
export const setNavigate = (fn: (path: string) => void) => {
  routerNavigate = fn;
};

// Trigger navigation (used by the other app)
export const navigate = (path: string) => {
  if (!routerNavigate) {
    console.warn('navigate() called before routerNavigate was set');
    return;
  }
  routerNavigate(path);
};
